import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import { useGetWorkbenchModelDataQuery } from "../service/apiSlices/sematicModel";
import { useDispatch } from "react-redux";
import { setHideConnectionExpiredModel, setSemanticModelName, setSemanticSecretKey, setShowConnectionExpiredModal } from "../service/apiSlices/staticApi";
import { isEmpty, isObject } from "lodash";
import { TOKENS } from "../utilities/Constants/Constants";

const WorkbenchContext = createContext({});
export const useWorkbenchContext: any = () => useContext(WorkbenchContext);

const WorkbenchProvider = ({ children }: { children: React.ReactNode }) => {
  const { sk } = useParams();
  const location = useLocation();
  const dispatch = useDispatch()

  const semanticData = sessionStorage.getItem("SemanticData");
  const connectionID = sessionStorage.getItem(TOKENS.CONNECTION_ID);
  const parsedData = semanticData ? JSON.parse(semanticData) : null;
  const secretKey = sk || parsedData?.secret_key || location?.state?.Id || "";

  const [workBenchData, setWorkBenchData] = useState<any>(null);
  const [skip, setSkip] = useState(false);

  const { data: workBenchResponse, isFetching } = useGetWorkbenchModelDataQuery(
    { secret_key: secretKey },
    { skip: !secretKey || skip }
  );

  useEffect(() => {
    return () => {
      dispatch(setSemanticModelName(""))
      dispatch(setSemanticSecretKey(""))
      sessionStorage.removeItem("SemanticData")
    }
  }, [])
  // Set initial data only once, then stop future API requests
  useEffect(() => {
    if (!connectionID) {
      dispatch(setShowConnectionExpiredModal());
      return;
    }
    // if (isObject(workBenchResponse?.data) && isEmpty(workBenchResponse?.data) && !workBenchResponse?.data?.connection_key) {
    //   dispatch(setShowConnectionExpiredModal());
    //   return;
    // }
    if (workBenchResponse?.data) {
      setWorkBenchData({ secret_key: secretKey, ...workBenchResponse.data });
      setSkip(true);
    }
    if (workBenchResponse?.data && !secretKey){
      setWorkBenchData(null)
    }
  }, [workBenchResponse, secretKey, connectionID]);

  useEffect(() => {
    return () => {
      dispatch(setHideConnectionExpiredModel())
    }
  }, [dispatch])

  const updateWorkBenchData = useCallback((values: any) => {
    setWorkBenchData((current: any) => ({ ...current, ...values }));
  }, []);

  const values: any = useMemo(
    () => ({
      workBenchData,
      isWorkbenchLoading: isFetching,
      updateWorkBenchData,
    }),
    [workBenchData, isFetching, updateWorkBenchData]
  );

  return (
    <WorkbenchContext.Provider value={values}>
      {children}
    </WorkbenchContext.Provider>
  );
};

export default WorkbenchProvider;
